// FreeAdmissionBand.js — the "start for free" front door under the home
// hero. Reads the free package from the same pricing data as /pricing, so
// it only shows while a package priced at zero exists (never hard-coded).
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getPricingPackages } from '../services/api';
import { isFreePackage, COMMITMENT_FEE_NOTE } from './Packages';
import { whatsappUrl } from '../utils/whatsapp';
import './FreeAdmissionBand.css';

export default function FreeAdmissionBand() {
  const { pathname } = useLocation();
  const [freePackage, setFreePackage] = useState(null);

  useEffect(() => {
    getPricingPackages()
      .then((data) => {
        const list = Array.isArray(data) ? data : (data.results || []);
        setFreePackage(list.find(isFreePackage) || null);
      })
      .catch(() => {});
  }, []);

  if (!freePackage) return null;

  return (
    <section className="free-band" aria-labelledby="free-band-heading">
      <div className="free-band-inner">
        <div className="free-band-text">
          <h2 id="free-band-heading" className="free-band-title">
            Start for free: apply with our {freePackage.name} package. No service fee.
          </h2>
          <p className="free-band-note">{COMMITMENT_FEE_NOTE}</p>
        </div>
        <div className="free-band-actions">
          <a
            href={whatsappUrl(pathname, { extra: `I'd like to start with the free ${freePackage.name} package.` })}
            target="_blank"
            rel="noopener noreferrer"
            className="free-band-cta"
          >
            Start on WhatsApp
          </a>
          <Link to="/pricing" className="free-band-link">See all packages</Link>
        </div>
      </div>
    </section>
  );
}
